import api from './config';

export const payrollConfigAPI = {
  // ─── Parámetros ───────────────────────────────────────────────
  getParametros: async () => {
    const response = await api.get('/payroll-config/parametros');
    return response.data;
  },

  saveParametros: async (parametros) => {
    const response = await api.put('/payroll-config/parametros', parametros);
    return response.data;
  },

  // ─── Conceptos ────────────────────────────────────────────────
  getConceptos: async () => {
    const response = await api.get('/payroll-config/conceptos');
    return response.data;
  },

  createConcepto: async (data) => {
    const response = await api.post('/payroll-config/conceptos', data);
    return response.data;
  },

  updateConcepto: async (id, data) => {
    const response = await api.put(`/payroll-config/conceptos/${id}`, data);
    return response.data;
  },

  deleteConcepto: async (id) => {
    const response = await api.delete(`/payroll-config/conceptos/${id}`);
    return response.data;
  },

  // ─── Tasas TSS ────────────────────────────────────────────────
  getTSSRates: async () => {
    const response = await api.get('/payroll-config/tss-rates');
    return response.data;
  },

  saveTSSRates: async (tasas) => {
    const response = await api.put('/payroll-config/tss-rates', tasas);
    return response.data;
  },

  // ─── Tipos de Ingresos ────────────────────────────────────────
  getIncomeTypes: async () => {
    const response = await api.get('/payroll-config/income-types');
    return response.data;
  },

  createIncomeType: async (data) => {
    const response = await api.post('/payroll-config/income-types', data);
    return response.data;
  },

  updateIncomeType: async (id, data) => {
    const response = await api.put(`/payroll-config/income-types/${id}`, data);
    return response.data;
  },

  deleteIncomeType: async (id) => {
    const response = await api.delete(`/payroll-config/income-types/${id}`);
    return response.data;
  },

  // ─── Tipos de Deducciones ─────────────────────────────────────
  getDeductionTypes: async () => {
    const response = await api.get('/payroll-config/deduction-types');
    return response.data;
  },

  createDeductionType: async (data) => {
    const response = await api.post('/payroll-config/deduction-types', data);
    return response.data;
  },

  updateDeductionType: async (id, data) => {
    const response = await api.put(`/payroll-config/deduction-types/${id}`, data);
    return response.data;
  },

  deleteDeductionType: async (id) => {
    const response = await api.delete(`/payroll-config/deduction-types/${id}`);
    return response.data;
  }
};
